/**
 * Shared Sentry tags and severity levels.
 * Aligns with API/frontend-user strategy for dashboards (ATT-2421).
 */

export const SENTRY_PROJECT = "frontend-admin";

export type SentrySeverity = "critical" | "warning" | "info";

export const SENTRY_TAGS = {
  project: "project",
  tenantId: "tenantId",
  userRole: "userRole",
  action: "action",
  environment: "environment",
  // ATT-2872: per-domain + per-tenant-slug attribution so a Sentry error
  // emitted from `admin.demo.attendly.com` is filterable separately from one
  // emitted from `admin.meetenrich.com` even when both target the same
  // backend tenant. Low cardinality, no PII.
  domain: "domain",
  tenantSlug: "tenantSlug",
} as const;
